import { render, staticRenderFns } from "./ChatMedia.vue?vue&type=template&id=3af2b33e&scoped=true"
import script from "./ChatMedia.vue?vue&type=script&lang=js"
export * from "./ChatMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2b33e",
  null
  
)

export default component.exports